import { WeighmentSitesAPI } from "api";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import ProductDisplayTable from "./ProductDisplayTable";
import { useSettingContext } from "context/SettingContext";

const BasicInformation = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  const {
    fields: details,
    append: appendDetails,
    remove: removeDetails,
    move,
  } = useFieldArray({
    control,
    name: "details",
  });

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);

  const settingsData = useSettingContext();
  const orderStatuses = useMemo(
    () => settingsData?.filter((d) => d.name === "ECOM_ORDER_STATUS"),
    [settingsData]
  );

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Number"
                  title="Number"
                  className="py-2 "
                  isInvalid={!!errors.number}
                  {...register("number")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.number?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Date"
                  title="Date"
                  className="py-2 "
                  isInvalid={!!errors.date}
                  {...register("date")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.date?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Customer"
                  title="Customer"
                  className="py-2 "
                  isInvalid={!!errors.customer}
                  {...register("customer")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.customer?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="number"
                  placeholder="Total Amount"
                  title="Total Amount"
                  className="py-2 "
                  isInvalid={!!errors.totalAmount}
                  {...register("totalAmount")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.totalAmount?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="status"
                  type="text"
                  title="Status"
                  className="py-2"
                  isInvalid={!!errors?.status}
                  {...register("status")}
                >
                  <option value="">Select Status</option>
                  {orderStatuses[0]?.value?.split(",").map((status) => (
                    <option key={status.trim()} value={status.trim()}>
                      {status.trim()}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.status?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          {/* <Row className="gx-2">
            <div
              style={{
                maxHeight: `calc(100vh - 20.7rem)`,
                overflowY: "auto",
                // border: "1px solid #ddd",
              }}
            >
              <Table
                className=""
                style={{ borderCollapse: "separate", borderSpacing: 0 }}
              >
                <thead
                  className="bg-200"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    background: "#fff",
                  }}
                >
                  <tr>
                    <th scope="col" className="fs-10">
                      #
                    </th>
                    <th scope="col" className="fs-10">
                      Product
                    </th>
                    <th scope="col" className="fs-10">
                      Variant
                    </th>
                    <th scope="col" className="fs-10">
                      Quantity
                    </th>
                    <th scope="col" className="fs-10">
                      Price
                    </th>
                    <th scope="col" className="fs-10">
                      Coupon
                    </th>
                    <th scope="col" className="fs-10">
                      Discount
                    </th>
                    <th scope="col" className="fs-10">
                      Shipping Charges
                    </th>
                  </tr>
                </thead>


                <tbody>
                  {details.map((item, index) => (
                    <tr key={item.id} id={item.id}>
                      <td className="text-center">{index + 1}</td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            placeholder="Product"
                            // className="text-end"
                            isInvalid={!!errors.details?.[index]?.product}
                            {...register(`details[${index}].product`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.product?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            placeholder="Variant"
                            isInvalid={!!errors.details?.[index]?.variant}
                            {...register(`details[${index}].variant`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.variant?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="number"
                            placeholder="Quantity"
                            isInvalid={!!errors.details?.[index]?.quantity}
                            {...register(`details[${index}].quantity`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.quantity?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="number"
                            placeholder="Price"
                            isInvalid={!!errors.details?.[index]?.price}
                            {...register(`details[${index}].price`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.price?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            placeholder="Coupon"
                            isInvalid={!!errors.details?.[index]?.coupon}
                            {...register(`details[${index}].coupon`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.coupon?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="number"
                            placeholder="Discount"
                            isInvalid={!!errors.details?.[index]?.discount}
                            {...register(`details[${index}].discount`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.discount?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                      <td style={{ padding: "10px" }}>
                        <Form.Group>
                          <Form.Control
                            type="number"
                            placeholder="Shipping Charges"
                            isInvalid={
                              !!errors.details?.[index]?.shippingCharges
                            }
                            {...register(`details[${index}].shippingCharges`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.details?.[index]?.shippingCharges?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Row> */}

          <ProductDisplayTable />
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
